// extracted by mini-css-extract-plugin
module.exports = {"heading":"PrivacyPolicyPage_heading__3w0hB","content":"PrivacyPolicyPage_content__DRM-M"};